import { DropdownMenu, useDropdownDirection } from '@consigli/facade';
import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { DeadlineDropdownContent } from './deadline-dropdown-content';

interface BulkUpdateDeadlinePopoverProps {
  isOpen: boolean;
  onSelect: (deadline: string | null) => void;
  onClose: () => void;
}

/**
 * Bulk deadline popover that reuses DeadlineDropdownContent for consistency.
 * Renders the same deadline picker as EditableDeadline but in a bulk context.
 */
export const BulkUpdateDeadlinePopover: FC<BulkUpdateDeadlinePopoverProps> = ({
  isOpen,
  onSelect,
  onClose,
}) => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);

  const openDirection = useDropdownDirection({
    containerRef,
    isOpen,
    dropdownHeight: 230,
  });

  return (
    <div className="relative" ref={containerRef}>
      <DropdownMenu
        isOpen={isOpen}
        direction={openDirection}
        header={t('meeting-secretary.action-items.update-deadline')}
        width="w-fit"
        onClick={(e: React.MouseEvent) => e.stopPropagation()}
        onKeyDown={(e: React.KeyboardEvent) => e.stopPropagation()}
      >
        <DeadlineDropdownContent onSelect={onSelect} onCancel={onClose} />
      </DropdownMenu>
    </div>
  );
};
